export const newsList = [
    "761ad1b03422",
    "fe993b7a765c",
    "dcfeb23adef",
    "1c7eef44ef0d",
    "950f9fd78956",
    "5374078bc9fc",
    "8d53138624f1",
];

export const newsData = [
    {
        id: "761ad1b03422",
        tags: {},
        claps: 0,
        last_modified_at: "2023-07-17 20:28:39",
        published_at: "2023-07-17 20:28:39",
        url: "https://medium.com/@sweetrain05/magna-ex-lorem-nisi-eiusmod-fugiat-id-sunt-nisi-irure-anim-amet-non-761ad1b03422",
        image_url:
            "https://miro.medium.com/v2/resize:fit:720/0*y3lpG-3vA0LzB3E2",
        is_series: false,
        lang: "la",
        publication_id: "*Self-Published*",
        word_count: 382,
        is_locked: false,
        title: "Magna ex Lorem nisi eiusmod fugiat id sunt nisi irure anim amet non",
        reading_time: 1.6415094339623,
        responses_count: 0,
        voters: 0,
        topics: {},
        author: "37bdb09bd139",
        subtitle:
            "Qui velit voluptate in ut deserunt duis labore. Do esse dolore reprehenderit do excepteur qui eiusmod laboris cillum Lorem. Nulla dolore…",
    },
    {
        id: "fe993b7a765c",
        tags: {},
        claps: 0,
        last_modified_at: "2023-07-17 20:26:58",
        published_at: "2023-07-17 20:26:58",
        url: "https://medium.com/@sweetrain05/officia-esse-in-consequat-labore-et-aute-fe993b7a765c",
        image_url: "https://miro.medium.com/0*zoB9ndK3fQX5PIDy",
        is_series: false,
        lang: "la",
        publication_id: "*Self-Published*",
        word_count: 378,
        is_locked: false,
        title: "Officia esse in consequat labore et aute",
        reading_time: 1.6264150943396,
        responses_count: 0,
        voters: 0,
        topics: {},
        author: "37bdb09bd139",
        subtitle:
            "Minim deserunt incididunt pariatur in. Proident laboris eiusmod qui adipisicing amet ipsum aliqua excepteur. Incididunt amet consequat nisi…",
    },
    {
        id: "dcfeb23adef",
        tags: {},
        claps: 0,
        last_modified_at: "2023-07-17 20:24:59",
        published_at: "2023-07-17 20:24:59",
        url: "https://medium.com/@sweetrain05/mollit-in-excepteur-veniam-non-eiusmod-sint-dcfeb23adef",
        image_url: "https://miro.medium.com/0*1G8EZmpAGa5HoCx_",
        is_series: false,
        lang: "la",
        publication_id: "*Self-Published*",
        word_count: 408,
        is_locked: false,
        title: "Mollit in excepteur veniam non eiusmod sint",
        reading_time: 1.7396226415094,
        responses_count: 0,
        voters: 0,
        topics: {},
        author: "37bdb09bd139",
        subtitle:
            "Dolore incididunt consequat laborum sunt consectetur duis anim consectetur sunt ad laborum. Incididunt aliquip reprehenderit laboris sunt…",
    },
    {
        id: "1c7eef44ef0d",
        tags: {},
        claps: 0,
        last_modified_at: "2023-07-17 07:34:06",
        published_at: "2023-07-17 07:34:06",
        url: "https://medium.com/@sweetrain05/ad-voluptate-pariatur-sit-velit-commodo-ex-1c7eef44ef0d",
        image_url: "https://miro.medium.com/0*AHI-obf3tr2XKIae.jpg",
        is_series: false,
        lang: "la",
        publication_id: "*Self-Published*",
        word_count: 370,
        is_locked: false,
        title: "Ad voluptate pariatur sit velit commodo ex",
        reading_time: 1.7795597484277,
        responses_count: 0,
        voters: 0,
        topics: {},
        author: "37bdb09bd139",
        subtitle:
            "Non aliquip labore id ad excepteur incididunt minim aliqua voluptate non sint culpa dolore tempor. Nulla anim consequat anim ut voluptate…",
    },
    {
        id: "950f9fd78956",
        tags: ["testing"],
        claps: 0,
        last_modified_at: "2023-07-17 07:31:17",
        published_at: "2023-06-21 08:32:04",
        url: "https://medium.com/@sweetrain05/test-article-3-950f9fd78956",
        image_url: "https://miro.medium.com/0*68Ym2qfwZj8B61fe.jpg",
        is_series: false,
        lang: "en",
        publication_id: "*Self-Published*",
        word_count: 381,
        is_locked: false,
        title: "Est qui commodo cupidatat elit laboris anim adipisicing",
        reading_time: 1.6377358490566,
        responses_count: 0,
        voters: 0,
        topics: ["poetry"],
        author: "37bdb09bd139",
        subtitle:
            "Amet aute sunt sunt laborum exercitation sint consectetur nisi incididunt non velit dolor amet. Excepteur sint tempor laboris enim fugiat…",
    },
    {
        id: "5374078bc9fc",
        tags: ["testing"],
        claps: 0,
        last_modified_at: "2023-07-17 07:31:51",
        published_at: "2023-06-21 08:31:29",
        url: "https://medium.com/@sweetrain05/test-article-2-5374078bc9fc",
        image_url: "https://miro.medium.com/0*KE_9gxikoySwjscK.jpg",
        is_series: false,
        lang: "en",
        publication_id: "*Self-Published*",
        word_count: 363,
        is_locked: false,
        title: "Exercitation ad veniam ullamco elit non",
        reading_time: 1.5698113207547,
        responses_count: 0,
        voters: 0,
        topics: ["poetry"],
        author: "37bdb09bd139",
        subtitle:
            "Culpa reprehenderit consectetur velit laboris qui enim excepteur anim incididunt nostrud elit cupidatat. Sint laborum deserunt…",
    },
    {
        id: "8d53138624f1",
        tags: ["testing"],
        claps: 0,
        last_modified_at: "2023-07-17 20:38:58",
        published_at: "2023-06-21 08:28:39",
        url: "https://medium.com/@sweetrain05/this-is-a-test-article-8d53138624f1",
        image_url: "https://miro.medium.com/0*hXpbfZluvibPpxda",
        is_series: false,
        lang: "en",
        publication_id: "*Self-Published*",
        word_count: 301,
        is_locked: false,
        title: "Elit nulla amet amet do consectetur anim velit consectetur",
        reading_time: 1.3358490566038,
        responses_count: 0,
        voters: 0,
        topics: ["poetry", "psychology", "self"],
        author: "37bdb09bd139",
        subtitle:
            "Id elit proident tempor proident labore ea labore sit in ad et. Qui nostrud commodo ut dolor quis do velit consequat consectetur eu magna…",
    },
];
